const PostaGuverciniChannelMenuTypes = {
    CHANNEL: {
        id: "detail",
        group: "settings_group",
        path: "detail",
        label: "Detail",
        tabs: [],
        implemented: true,
    },
    SEND_SMS: {
        id: "postaGuverciniMessage",
        group: "message_group",
        path: "postaGuverciniMessage",
        label: "postaGuverciniMessage",
        tabs: [],
        implemented: true,
    },
};

export default PostaGuverciniChannelMenuTypes;
